<template>
    <div>
        <div class="header">
            <img src="../../assets/logo/krishifyLogo.svg" alt="" />
            <p class="headerText">Krishify Business</p>
        </div>
        <div class="navigationTab">
            <div v-if="loginClicked"><p class="tabSelected">Login</p></div>
            <div v-if="!loginClicked" v-on:click="toggleTab('login')"><p class="tabNotSelected">Login</p></div>

            <div v-if="registerClicked"><p class="tabSelected">Register</p></div>
            <div v-if="!registerClicked" v-on:click="toggleTab('register')"><p class="tabNotSelected">Register</p></div>
        </div>
        <div v-if="loginClicked" class="main-div">
            <div class="contentText">
                <p class="contentHeaderText">Krishify Business Suite is not available on Smartphone</p>
                <p class="contentSubHeaderText">
                    Please login using your desktop or laptop browser to access the application.
                </p>
            </div>
            <div class="contentImage">
                <img style="max-width: 320px" src="../../assets/FrontPage/laptop.png" alt="" />
            </div>
            <div class="footer-div" style="cursor: pointer" @click="gotoHome()">
                <p class="footerText">Take me back to the website</p>
            </div>
        </div>
        <div v-if="registerClicked" class="main-div-register">
            <p class="createText">Create an account</p>
            <login-with-google :params="params" :onSuccess="signInOrRegisterWithGmail">
                <button class="sign-in-with-gmail flex">
                    <img src="@/assets/FrontPage/GmailIcon.svg" class="mx-5" alt="" />
                    Sign up with Gmail
                </button>
            </login-with-google>
            <p class="termsAndConditionText">
                By creating an account, you agree to Krishify Business'
                <a href="https://krishify.com/terms-of-use" target="blank" style="text-decoration: none"
                    ><span style="color: #339137">Conditions of Use</span>
                </a>
                and
                <a href="https://krishify.com/privacy-policy" style="text-decoration: none" target="blank">
                    <span style="color: #339137"> Privacy Policy.</span>
                </a>
            </p>
        </div>
        <div v-if="registerClicked" class="footer-companies">
            <Companies />
        </div>
    </div>
</template>

<script>
import loginSignupForm from "../FrontPage/components/login-signup-form.vue";
import trustedByCompanies from "../FrontPage/components/trustedCompanies.vue";
import API_URL from "../../helpers/apiUrls";
import accessToken from "../../helpers/accessToken";
import MoengageEventGenerator from "../../helpers/moengageEventGenerator";
import MoengageEvents from "../../helpers/moengageEvents";
import MoengageAtrributes from "../../helpers/moengageAttributes";

export default {
    name: "loginPageMobile",
    components: {
        "login-signup": loginSignupForm,
        Companies: trustedByCompanies,
    },
    data() {
        return {
            loginClicked:true,
            registerClicked:false,
            isMobile:false,
            params: {
                client_id: "", // Google client ID
                fetch_basic_profile: true,
            },
        };
    },
    created() {
        (this.params.client_id = process.env.VUE_APP_GOOGLE_CLIENT_ID),
            (this.MoengageIsActive = process.env.VUE_APP_MOENGAGE_ACTIVE);
    },
    mounted(){
        this.checkDevices();
          if(sessionStorage.getItem("buttonType")=="login"){
          this.loginClicked=true;
          this.registerClicked=false;
          }
          else if(sessionStorage.getItem("buttonType")=="register"){
          this.registerClicked=true;
          this.loginClicked=false;
          }

    },
    methods:{
        gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;

    },
        gotoHome(){
        this.$router.push({name:"landingPage"})
        },
        toggleTab(tabItem) {
            if (tabItem == "login") {
                this.loginClicked = true;
                this.registerClicked = false;
            } else if (tabItem == "register") {
                this.registerClicked = true;
                this.loginClicked = false;
            }
        },
        signInOrRegisterWithGmail(user) {
            const successHandler = (response) => {
                if (response.status === 200) {
                    const moengageAttr = {
                        [MoengageAtrributes.IsUserGenerated]: "TRUE",
                        [MoengageAtrributes.Source]: "BSLandingPage",
                        // [MoengageAtrributes.ButtonClicked]:"Log In with Email",
                        [MoengageAtrributes.Device]: "Mobile",
                        [MoengageAtrributes.LoginMode]: "Register with Gmail",
                        [MoengageAtrributes.SignupResult]: "Success",
                        [MoengageAtrributes.Platform]: "Web",
                        [MoengageAtrributes.TabName]: "Register",
                    };
                    MoengageEventGenerator(MoengageEvents.LoginPageAction, moengageAttr);
                    this.gtagEventHandler(MoengageEvents.LoginPageAction,moengageAttr);

                    const userData = {
                        name: response.data.user.full_name,
                        avatar: response.data.user.image ? response.data.user.image.medium : "",
                        brandID: response.data.brand ? response.data.brand.id : null,
                        brandName: response.data.brand ? response.data.brand.name : "",
                    };
                    this.$store.dispatch("mainStore/setUserDetails", userData);
                    // if(response.data.brand && process.env.VUE_APP_MOENGAGE_ACTIVE !== 'false'){
                    //         this.getAndSetEmailMoengage(response.data.brand.id,response.data.access);
                    //         window?.Moengage.add_unique_user_id(response.data.brand.id);
                    //         window?.Moengage.add_first_name(response.data.user.full_name);

                    //     }
                    this.handleNavigations(response);
                }
            };

            const errorHandler = (error) => {
                const moengageAttr = {
                    [MoengageAtrributes.IsUserGenerated]: "TRUE",
                    [MoengageAtrributes.Source]: "BSLandingPage",
                    // [MoengageAtrributes.ButtonClicked]:"Log In with Email",
                    [MoengageAtrributes.Device]: "Mobile",
                    [MoengageAtrributes.LoginMode]: "Register with Gmail",
                    [MoengageAtrributes.SignupResult]: "failure",
                    [MoengageAtrributes.Platform]: "Web",
                    [MoengageAtrributes.TabName]: "Register",
                };
                MoengageEventGenerator(MoengageEvents.LoginPageAction, moengageAttr);
                this.gtagEventHandler(MoengageEvents.LoginPageAction,moengageAttr);

                console.log(error);
            };

            const data = {
                token: user.getAuthResponse().id_token,
                provider: "google",
            };

            this.requestPOST(API_URL.loginOrRegister, data, {}, successHandler, errorHandler);
        },

        handleNavigations(response) {
            console.log("handleNavigations", response);
            if (!response.data.brand) {
                this.$store.state.mainStore.temporaryAccessToken = response.data.access;
                this.$store.state.mainStore.temporaryRefreshToken = response.data.refresh;
                this.$router.replace({ name: "setupProfileDetails" });
                console.log("handleNavigations", "setupProfileDetails");
            } else {
                this.$store.state.mainStore.user.brand.brandID = response.data.brand.id;
                this.$store.state.mainStore.user.brand.name = response.data.brand.name;
                this.$store.state.mainStore.user.brand.description = response.data.brand.description;
                this.$store.state.mainStore.user.brand.categoryID = response.data.brand.brand_category?.id;

                if (response.data.brand.logo_image && response.data.brand.time_line_image) {
                    accessToken.setCredentials(
                        response.data.access,
                        response.data.refresh,
                        response.data.brand.id,
                        response.data.user.full_name,
                        response.data.user.image ? response.data.user.image.medium : "",
                        response.data.brand.name,
                        response.data.brand.logo_image.thumbnail
                    );
                    if (response.data.brand.verification_status === "verified") {
                        this.$router.replace({ name: "createContent" });
                        console.log("verified", "createContent");
                    } else this.$router.replace({ name: "verifyCurtain" });

                    this.showToast("You have successfully logged in!");
                } else if (response.data.brand.logo_image && !response.data.brand.time_line_image) {
                    this.$store.state.mainStore.temporaryAccessToken = response.data.access;
                    this.$store.state.mainStore.temporaryRefreshToken = response.data.refresh;
                    this.$router.replace({ name :!this.isMobile ? 'setupProfileTimeline':'setupProfileCoverMobile', params : { brandDetails : response.data.brand } })
                }
                else {
                    this.$store.state.mainStore.temporaryAccessToken = response.data.access;
                    this.$store.state.mainStore.temporaryRefreshToken = response.data.refresh;
                    this.$router.replace({ name :!this.isMobile ?'setupProfileLogo':'setupProfileLogoMobile', params : { brandDetails : response.data.brand } })
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main-div {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: calc(100vh - 133px);
}
.main-div-register {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 300px);
    justify-content: center;
    gap: 24px;
    text-align: start;
    padding: 20px;
}
.sign-in-with-gmail {
    color: #757575;
    font-size: 16px;
    font-weight: normal;
    background-color: white;
    border: 0.5px solid #474747;
    border-radius: 3px;
    height: 54px;
    width: 100%;
}
.createText {
    font-weight: 400;
    font-size: 22px;
    color: #3a3f3a;
    margin: 0px;
}
.termsAndConditionText {
    font-weight: 400;
    font-size: 12px;
    color: #474747;
}
.navigationTab {
    height: 69px;
    background-color: #f9f9f9;
    display: flex;
    align-items: end;
    padding-left: 20px;
    gap: 16px;
}
.tabSelected {
    margin: 0px;
    transform: translateY(2px);
    border-bottom: 2px solid #3a3f3a;
    padding-bottom: 14px;
    font-weight: 500;
    font-size: 20px;
    color: #3a3f3a;
}
.tabNotSelected {
    margin: 0px;
    padding-bottom: 14px;
    font-weight: 400;
    font-size: 20px;
    color: #797e79;
}
.header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    height: 64px;
    background: #ffffff;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.07);
}
.headerText {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */

    text-transform: uppercase;
    margin-bottom: 0px;
    color: #3a3f3a;
}

.contentText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin: 0px auto;
}
.contentHeaderText {
    font-weight: 400;
    font-size: 22px;
    line-height: 130%;
    /* or 29px */

    text-align: center;

    /* Grey */

    color: #3a3f3a;
}
.contentSubHeaderText {
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    /* or 18px */

    display: flex;
    align-items: center;
    text-align: center;

    /* Light Grey */

    color: #797e79;
}
.contentImage {
    display: flex;
    justify-content: center;
    align-items: center;
}

.footer-div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    height: 64px;
    background: #f9f9f9;
}
.footerText {
    font-weight: 500;
    font-size: 14px;
    line-height: 0px;
    /* identical to box height, or 0% */
    letter-spacing: 0.03em;
    margin: 0px;
    color: #37893c;
}
.footer-companies {
    div {
        padding-top: 20px !important;
        width: 100%;
        padding: 20px;
    }
}
</style>
